import styled from 'styled-components'
import { NavLink as NL, Link } from 'react-router-dom'

import { Logo } from 'assets/images/Logo'
import { NavIcon } from 'images/SVGs/NavIcon'

export const Container = styled.div`
	width: 100%;
	position: absolute;
	top: 0px;
	left: 0px;
`
export const Content = styled.div`
	width: 100%;
	max-width: 1400px;
	margin: 0px auto;
	padding: 50px;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;

	@media (max-width: 800px) {
		padding: 40px;
	}
	@media (max-width: 650px) {
		padding: 30px;
	}
	@media (max-width: 450px) {
		padding: 20px;
	}
`
export const LogoContainer = styled.div``
export const LogoLink = styled(Link)`
	text-decoration: none;
`
export const LogoSVG = styled(Logo)`
	width: 100px;
	fill: ${(props) => props.theme.white};

	@media (max-width: 800px) {
		width: 80px;
	}
`
export const NavList = styled.ul`
	padding: 0px;
	margin: 0px;
	display: flex;
	justify-content: flex-end;
	height: auto;
	align-items: center;
`
export const NavItem = styled.li`
	padding: 0px 15px;
	margin: 0px;
	list-style: none;

	@media (max-width: 450px) {
		padding: 0px 10px;
	}
`
export const NavLink = styled(NL)`
	text-decoration: none;
	color: ${(props) => props.theme.white};
	text-align: center;
	font-size: 16px;

	&.active {
		font-weight: bold;
	}
`
export const NavLinkButton = styled(NL)`
	text-decoration: none;
	color: ${(props) => props.theme.primary};
	text-align: center;
	background-color: ${(props) => props.theme.white};
	padding: 15px 30px;
	display: inline-block;
	font-size: 16px;

	&.active {
		/* color: ${(props) => props.theme.primary}; */
		/* font-weight: bold; */
	}

	@media (max-width: 800px) {
		padding: 12px 25px;
		font-size: 15px;
	}
`
export const MobileMenuButton = styled.button`
	position: absolute;
	display: none;
`
export const MobileMenuButtonIcon = styled(NavIcon)`
	width: 100%;
	height: auto;
	fill: currentColor;
`
